import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-12">
          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-light text-foreground-500 leading-tight">
              Artykuły SEO
            </h2>
            <h3 className="text-2xl md:text-3xl font-heading font-bold italic text-foreground-950 mt-1">
              Przewodniki i Rankingi
            </h3>
          </div>
          <p className="lg:w-1/3 text-sm text-foreground-600 leading-relaxed">
            Poznaj nasze szczegółowe poradniki i artykuły. Dowiedz się więcej o bezpiecznych zakupach, porównaniach platform i najlepszych produktach.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/artykul/${article.slug}`}
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300"
            >
              <div className="relative h-52 md:h-56 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 rounded-full bg-white/85 backdrop-blur-sm text-accent-800 text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-accent-600 group-hover:text-accent-700 transition-colors whitespace-nowrap">
                  Czytaj więcej <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}